import { render, staticRenderFns } from "./AffiliateCommisions.vue?vue&type=template&id=296c140a"
import script from "./AffiliateCommisions.vue?vue&type=script&lang=js"
export * from "./AffiliateCommisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports